// extracted by mini-css-extract-plugin
module.exports = {"container":"checkbox_container__KXY_b","control":"checkbox_control__e5zKE","input":"checkbox_input__PCozC","label":"checkbox_label__BL__u"};